import PropTypes from 'prop-types';
import React from 'react';
import BookForm from './BookForm';
import Container from '../../ui/Container';
import Footer from '../../ui/Footer';
import LarsImage from '../../ui/LarsImage';
import Layout from '../../ui/Layout';
import SectionWrap from '../../ui/SectionWrap';
import styled from 'styled-components';
import { RIGHT_FACING_ARROW } from '../../ui/SVGIcon';
import { useForm, FormProvider } from 'react-hook-form';
import Header from '../../ui/Header';

const Form = styled.form`
  all: unset;
`;

const Book = ({
  client,
  isLoading,
  isMaintenanceModeActive,
  handleBookSubmit,
  history,
  hasTopBanner,
}) => {
  const methods = useForm();
  const { handleSubmit } = methods;

  const onSubmit = payload => {
    handleBookSubmit({
      client,
      payload,
      redirect: history.push,
    });
  };

  const formatPhoneWithDashes = phone => {
    const formattedPhone = phone.split('');
    formattedPhone.splice(6, 1, '-');
    formattedPhone.splice(10, 1, '-');

    return formattedPhone.join('');
  };

  const formatPhoneWithParentheses = phone => {
    const formattedPhone = phone.replace(/([()])/g, '').split('');
    formattedPhone.splice(5, 1, '-');

    return `+${formattedPhone.join('')}`;
  };

  const formatPhoneNumber = phone => {
    if (phone.indexOf('+1 ') === 0) {
      return formatPhoneWithDashes(phone);
    }
    if (phone.indexOf('1 ') === 0) {
      const formattedNumber = formatPhoneWithParentheses(phone);
      return `+${formattedNumber}`;
    }
    return phone;
  };

  const createPayload = ({ countryCode, phone, timeZone, company }) => ({
    company,
    phone: formatPhoneNumber(phone),
    timeZone: timeZone?.value,
    countryCode: countryCode?.value,
  });

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(fieldValues => onSubmit(createPayload(fieldValues)))}>
        <Layout>
          <Layout.Sidebar>
            <LarsImage />
          </Layout.Sidebar>
          <Layout.Page hasSidebar hasTopBanner={hasTopBanner}>
            <SectionWrap>
              <Container minWidth="580px" topPadding="64px">
                <Header
                  headerText={
                    client.firstName
                      ? `Thanks ${client.firstName}, and how can our team contact you?`
                      : 'Thanks, and how can our team contact you?'
                  }
                  subHeaderText="A Bench Expert will give you a call to understand your business needs, take a tour of the platform, and get you started with your free month of bookkeeping."
                />
                <BookForm isLoading={isLoading} client={client} />
              </Container>
            </SectionWrap>
          </Layout.Page>
          <Layout.Footer hasSidebar>
            <Footer
              hasNext
              icon={RIGHT_FACING_ARROW}
              isLoading={isLoading}
              onClickNext={handleSubmit}
              text={isMaintenanceModeActive ? 'Finish Signing Up' : 'Next'}
            />
          </Layout.Footer>
        </Layout>
      </Form>
    </FormProvider>
  );
};

export default Book;

Book.propTypes = {
  isLoading: PropTypes.bool,
  client: PropTypes.object.isRequired,
  handleBookSubmit: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isMaintenanceModeActive: PropTypes.bool,
  hasTopBanner: PropTypes.bool.isRequired,
};

Book.defaultProps = {
  isMaintenanceModeActive: false,
  isLoading: false,
};
